import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from '../src/pages/Navbar';
// import Home from '../src/pages/Home';
import About from '../src/pages/About';
// import Engraving from '../src/pages/Engraving';
// import LaserPrinting from '../src/pages/LaserPrinting';
import Inquiry from '../src/pages/CustomerInquiry.jsx';
import Contact from '../src/pages/Contact';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        {/* <Route path="/mbjtech" element={<Home />} />
      
        <Route path="/engraving" element={<Engraving />} />
        <Route path="/laser-printing" element={<LaserPrinting />} /> */}
        <Route path="/inquiry" element={<Inquiry />} />
        <Route path="/" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
